var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSucc = function SvgSucc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    fill: "none",
    viewBox: "0 0 13 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#43C25C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m1 7.545 2.633 1.91a1 1 0 0 0 1.351-.163L12 1"
  })));
};
export default SvgSucc;